import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { TriggerAction } from '@shared/actions';
import { ButtonOutline } from '@shared/buttons/button-outline/button-outline.data';
import { ConfirmDialogService } from '@shared/confirm-dialog';
import {
  ConfirmDialogAnswer,
  ConfirmDialogResults,
} from '@shared/confirm-dialog/confirm-dialog.data';
import { ROLE } from '@shared/helpers/constants';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { ProjectActionsRequestService } from '@viewer/services';
import { LogMessageAction } from '@viewer/services/log-event.data';

@Component({
  selector: 'app-download-log-action',
  templateUrl: 'download-log-action.component.html',
  styleUrls: ['download-log-action.component.scss'],
})
export class DownloadLogActionComponent implements OnInit, OnDestroy {
  readonly ButtonOutline = ButtonOutline;

  public downloadLogAction: TriggerAction;
  public isManagerRole = false;

  private _unsubscribe$ = new Subject();

  constructor(
    public stateManagerProjectService: StateManagerProjectService,
    private _projectActionsRequestService: ProjectActionsRequestService,
    private _confirmDialogService: ConfirmDialogService
  ) {
    this.downloadLogAction = new TriggerAction(
      '',
      'Actions.DOWNLOAD_LOG',
      () => {
        this._confirmDialogService
          .openConfirmDialog(
            'Dialog.DOWNLOAD_LOG_MESSAGE',
            'Dialog.RejectButtons.EXIT',
            'Dialog.ConfirmButtons.SELECT_FOLDER'
          )
          .pipe(takeUntil(this._unsubscribe$))
          .subscribe((res: ConfirmDialogAnswer) => {
            if (res.result === ConfirmDialogResults[1]) {
              const selectFolderAndSaveLog = async () => {
                const opts = {
                  types: [
                    {
                      description: 'CSV file',
                      accept: { 'text/csv': ['.csv'] },
                    },
                  ],
                  suggestedName: `${this.stateManagerProjectService.caseId} Audit Log`,
                };

                const dirHandle = await window.showSaveFilePicker(opts);

                if (dirHandle) {
                  this._projectActionsRequestService
                    .requestGetLogForCase(
                      this.stateManagerProjectService.caseId
                    )
                    .subscribe((log: string) => {
                      const blob = new Blob([log]);
                      saveLogInSelectedFolder(dirHandle, blob);
                      this._projectActionsRequestService
                        .requestSaveLogForCase(
                          this.stateManagerProjectService.caseId,
                          this.stateManagerProjectService.currentUserName,
                          LogMessageAction.CaseDownload,
                          new Date().toISOString(),
                          1,
                          'UPDATE'
                        )
                        .subscribe();
                    });
                }
              };
              async function saveLogInSelectedFolder(
                dirHandle: any,
                blob: Blob
              ) {
                const writable = await dirHandle.createWritable();
                await writable.write(blob);
                await writable.close();
              }
              selectFolderAndSaveLog();
            }
          });
      }
    );
  }

  ngOnInit(): void {
    this.isManagerRole = (JSON.parse(localStorage.getItem('userDetails') || '{}').userRole === ROLE.SNN_HIL_MANAGER) ||
    (JSON.parse(localStorage.getItem('userDetails') || '{}').userRole === ROLE.SNN_HIL_REVIEWER);
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(undefined);
    this._unsubscribe$.complete();
  }
}
